<template>
  <v-card
    class="actions-dialog"
    :style="`max-width: ${maxWidth}px`"
  >
    <v-card-title class="actions-dialog__close pa-0">
      <v-btn
        text
        icon
        plain
        depressed
        class="ma-0"
        @click="close"
      >
        <v-icon
          dense
        >
          mdi-close
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text
      v-if="titleText"
      class="pt-0 actions-dialog__title"
    >
      {{ titleText }}
    </v-card-text>

    <v-card-text class="pt-0 actions-dialog__content">
      {{ dialogText }}
    </v-card-text>

    <v-card-text
      v-if="supportText"
      class="py-0 font-weight-bold"
    >
      {{ supportText }}
    </v-card-text>

    <v-card-actions class="actions-dialog__actions px-0 ma-0">
      <v-btn
        v-if="firstText"
        class="actions-dialog__btn actions-dialog__btn__first"
        medium
        depressed
        outline
        @click="firstAction"
      >
        {{ firstText }}
      </v-btn>
      <v-btn
        v-if="secondText"
        class="actions-dialog__btn actions-dialog__btn__second ma-0"
        medium
        depressed
        @click="secondAction"
      >
        {{ secondText }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      default: '',
    },
    dialogText: {
      type: String,
      default: '',
    },
    supportText: {
      type: String,
      default: '',
    },
    firstText: {
      type: String,
      default: '',
    },
    secondText: {
      type: String,
      default: '',
    },
    firstAction: {
      type: Function,
      default: () => {},
    },
    secondAction: {
      type: Function,
      default: () => {},
    },
    close: {
      type: Function,
      default: () => {},
    },
    maxWidth: {
      type: Number,
      default: 342,
    },
  },
};
</script>

<style scoped lang="scss">

.actions-dialog {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  text-transform: none;
  border-radius: 7px;
  padding: 16px 24px 32px 24px;
  &__title {
    display: flex;
    color: var(--brand-primrias-connect-black, #140C22);
    text-align: center;
    font-family: Nunito Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    padding: 0px;
    width: 288px;
    padding-bottom: 16px;
  }
  &__content {
    display: flex;
    color: var(--brand-primrias-connect-black, #140C22);
    font-family: Nunito Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    width: 288px;
    padding: 0px !important;
  }
  &__actions {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 40px 0px 0px 0px !important;
  }
  &__btn {
    width: 288px;
    height: 42px;
    border-radius: 7.08982px;
    text-transform: none;
    font-weight: 600;
    &__first {
      color: #FFF !important;
      background-color: #140C22 !important;
      font-family: Nunito Sans;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 102%;
    }
    &__second {
      color: var(--brand-extendidas-red, #FF5146);
      background-color: transparent !important;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
  &__close {
    display: flex;
    justify-content: end;
    position: relative;
    right: -15px;
  }
}

</style>
